import { VALIDATION_TEMPLATE } from './validationTemplete';

export const EMPLOYEE_VALIDATION = {
  FIELDS: ['employeeCode', 'name', 'password'],
  MESSAGE: {
    employeeCode: {
      required: VALIDATION_TEMPLATE.required('社員コード'),
      isHalfWidth: VALIDATION_TEMPLATE.isHalfWidth('社員コード'),
      startsWithDIfDairen: VALIDATION_TEMPLATE.startsWithDIfDairen(),
    },
    name: {
      required: VALIDATION_TEMPLATE.required('氏名'),
    },
    password: {
      required: VALIDATION_TEMPLATE.required('パスワード'),
      pattern: VALIDATION_TEMPLATE.pattern('パスワード'),
      lengthCheck: VALIDATION_TEMPLATE.lengthCheck('8文字'),
      isHalfWidth: VALIDATION_TEMPLATE.isHalfWidth('パスワード'),
    },
  },
  RULES: {
    employeeCode: {
      required: true,
      isHalfWidth: /^[\x20-\x7E]+$/, // 半角
      startsWithDIfDairen: (v: string, all: any) =>
        !all?.isDairen || /^D/.test(v),
    },
    name: {
      required: true,
    },
    password: {
      required: true,
      pattern: /^[A-Za-z0-9]+$/, // 英数字
      lengthCheck: /^.{8,}$/, // 8文字以上
      isHalfWidth: /^[\x20-\x7E]+$/, // 半角
    },
  },
};
